import React from 'react'
import { useEffect, useState, useRef } from 'react';
import './Notification.css'                 //css of datepicker
import './Notification2.css'                //css of the page (header only)
import './Notification3.css'                //css for the page (table)
import { connect } from 'react-redux'
import icon from './images/icons8-place-marker-48.png';
import iconhover from './images/icons8-place-marker.gif';
//libraries
import DatePicker from 'react-datepicker'
import Table from './Table'
import SoundPlay from '../Sound/Sound'
import {getTxt} from '../common/language/language'
import {GetSiteName, GetLvlName} from '../common/language/locDisplay'
import groundFloor from './images/YTMapNew.png';
import * as XLSX from 'xlsx';

import axios from "axios";
import * as signalR from "@microsoft/signalr";
//import { set } from '../../../../../../../../AppData/Local/Microsoft/TypeScript/5.1/node_modules/date-fns/set';

export default function Notification() {

    //const tArray = useRef([]);
    const [tArray, setTArray] = useState([]);
    const [retry, setRetry] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedType, setSelectedType] = useState('0');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const [pins_g, setPins_g] = useState([]);
    const [recordsDetails, setRecordsDetails] = useState([]);

    const handleSelectedType = (event) => {
        setSelectedType(event.target.value);
    };

    /*const handleSelectedStatus = (event) => {
        setSelectedStatus(event.target.value);
    };*/
    const itemsPerPage = 10;

    const handleStartDateChange = (date) => {
        setStartDate(date);
    }

    const handleEndDateChange = (date) => {
        setEndDate(date);
    }


    const connection = new signalR.HubConnectionBuilder()
        .withUrl("/devicehub")
        .build();

    //const PinIcon = ({ id, x, y, src, hoverSrc, scale }) => {
    const PinIcon = ({x, y, src}) => {
        // Use a state variable to keep track of whether the mouse is over the icon or not.
        //const [isHovered, setIsHovered] = useState(false);

        // Define a function that handles the mouse enter event and sets the state to true.
        /*const handleMouseEnter = () => {
            //setIsHovered(true);
            switch (dev[id - 1].data_type) {
                case 1:
                    handleClick(1);
                    handleCellHilight(id - 1);
                    break;
                case 2:
                    handleClick(2);
                    handleCellHilight(id - 12);
                    break;
                case 3:
                    handleClick(3);
                    handleCellHilight(id - 28);
                    break;
                case 4:
                    handleClick(4);
                    handleCellHilight(id - 34);
                    break;
                default:
            }
            setIsHovered(id);

        };

        // Define a function that handles the mouse leave event and sets the state to false.
        const handleMouseLeave = () => {
            setIsHovered(false);
            handleCellNormal();

        };*/

        // Return a JSX element that renders an image tag with the appropriate attributes and styles.
        return (
            <img
                //src={isHovered === id ? hoverSrc : src} // Use the hoverSrc if the mouse is over the icon, otherwise use the src.
                src={src} // Use the hoverSrc if the mouse is over the icon, otherwise use the src.
                alt="pin icon" // Provide an alternative text for accessibility.
                style={{
                   position: "absolute", // Use absolute positioning to place the icon on top of the background image.
                    //left: isHovered === id ? (x - 11) : x + "px", // Use the x prop as the left offset in pixels.
                    //top: isHovered === id ? (y - 18) : y + "px", // Use the y prop as the top offset in pixels.
                    //width: isHovered === id ? "48px" : "25px", // Set a fixed width for the icon in pixels. You can change this as you like.
                    //height: isHovered === id ? "48px" : "25px", // Set a fixed height for the icon in pixels. You can change this as you like.
                    left: x + "px", // Use the x prop as the left offset in pixels.
                    top: y + "px", // Use the y prop as the top offset in pixels.
                    width: "25px", // Set a fixed width for the icon in pixels. You can change this as you like.
                    height: "25px", // Set a fixed height for the icon in pixels. You can change this as you like.
                    transition: "transform 0.3s ease-in-out", // Use a transition effect to animate the icon when it changes size on hover.
                }}
                //onMouseEnter={handleMouseEnter} // Attach the mouse enter handler to the image tag.
                //onMouseLeave={handleMouseLeave} // Attach the mouse leave handler to the image tag.
                fluid
                width="400px"
            />
        );
    }


    const ImageWithPins = ({ pins }) => {
        return (
            <div>
                {pins.map((pin) => (
                    // For each pin object in the pins array, render a PinIcon component with its properties as props.
                    <PinIcon
                        key={pin.x + "," + pin.y} // Use a unique key for each PinIcon component based on its coordinates.
                        id={pin.id}
                        x={pin.x} // Pass the x coordinate as a prop.
                        y={pin.y} // Pass the y coordinate as a prop.
                        src={icon}
                        hoverSrc={iconhover}
                    />
                ))}
            </div>
        );
    }


    useEffect(() => {

        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://yantindash.ddns.net', // The base URL of your web application
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // Call the web API endpoint with GET method
        const getData = async () => {

            var connectionPath = '/api/yantinpastrecord/1/10/';
            //var tArray;
            await httpClient.get(connectionPath)
                            .then((response) => {
                                    let mArray = response.data.map((item) => ({
                                        Id: item.item,
                                        Label: item.label,
                                        Status: item.status,
                                        DataType: item.dataType,
                                        Timestamp: item.timestamp,
                                        Acknowledge: item.acknowledge,
                                        Name: item.name
                                    }));
                                    console.log(mArray);
                                    setTArray(mArray);
                                    console.log(tArray);
                                }
                            )
                            .catch(error => {
                                    // Handle the error
                                    console.error(error);
                                    setRetry(true);
                                }
                            );
        };

        const getCount = async () => {

            var connectionPath = '/api/yantinpastrecord/count';
            //var tArray;
            await httpClient.get(connectionPath)
                            .then((response) => {
                                setPageCount(response.data);
                                console.log(response.data);
                            })
                            .catch(error => {
                                // Handle the error
                                console.error(error);
                                setRetry(true);
                            }
                            )
        };

        getCount();
        getData();

    }, []);

    useEffect(() => {

        console.log("Change page...");
        const httpClient = axios.create({
            baseURL: 'https://yantindash.ddns.net', // The base URL of your web application
            headers: {
                'Content-Type': 'application/json'
            }
        });


        const getData = async () => {

            var connectionPath = '/api/yantinpastrecord/' + currentPage.toString() + '/10/';
            //var tArray;
            await httpClient.get(connectionPath)
                .then((response) => {
                    let mArray = response.data.map((item) => ({
                        Id: item.item,
                        Label: item.label,
                        Status: item.status,
                        DataType: item.dataType,
                        Timestamp: item.timestamp,
                        Acknowledge: item.acknowledge,
                        Name: item.name
                    }));
                    console.log(mArray);
                    setTArray(mArray);
                    console.log(tArray);
                }
                )
                .catch(error => {
                    // Handle the error
                    console.error(error);
                    setRetry(true);
                }
                );
        };
        getData();

    }, [currentPage]);

    // A custom component that displays an image
    function FloorplanImage(props) {
        return (
            <div className="estate-image" align-items="center">
                < img src={props.src} alt={props.alt} width="700" />
            </div>
        );
    }

    function TableList() {
        return (
            <div className="Table_maindiv">
                <table className="shadow-lg Table_tablediv" style={{
                    color: "#f7f4ef"                }}>
                <tr className="Table_tableheader">
                    <td className="headerfirstitem" width="10rem">位置</td>
                    <td>報警名稱</td>
                    <td>報警狀態</td>
                    <td>創建時間</td>
                    </tr>
                    
                        {Array.isArray(tArray) &&
                            tArray.map((product, index) => (
                                <tr className="Table_rowItem" key={index}>

                                    <td>{product.Name}</td>
                                    <td>{product.Label}</td>
                                    <td>{product.Status}</td>
                                    <td>{product.Timestamp}</td>

                                </tr>
                            ))
                        }
                   

            </table>
            </div>
        )
    }

    const Pagination = () => {
        //const [currentPage, setCurrentPage] = useState(1);
        const maxPage = Math.ceil(pageCount / itemsPerPage);

        /*function currentData() {
            const begin = (currentPage - 1) * itemsPerPage;
            const end = begin + itemsPerPage;
            return data.slice(begin, end);
        }*/


        const getPaginationGroup = () => {
            let start = Math.floor((currentPage - 1) / 5) * 5;
            return new Array(5).fill().map((_, idx) => start + idx + 1);
        };

        return (
            <>
                <div className='pagination'>
                    <button
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                    >
                        prev
                    </button>
                    {getPaginationGroup().map((item, index) => (
                        <button
                            key={index}
                            onClick={() => setCurrentPage(item)}
                            disabled={item > maxPage}
                            style={{ fontSize: item === currentPage ? "18px" : "12px", fontWeight: item === currentPage ? 'bold' : 'normal' }}
                        >
                            {item}
                        </button>
                    ))}
                    <button>
                        Total {maxPage} Pages
                    </button>
                    <button
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, maxPage))}
                        disabled={currentPage === maxPage}
                    >
                        next
                    </button>
                </div>

            </>
        );
    };

    const exportToExcel = (data, fileName) => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };

    // Handle button click
    const handleSearchClick = () => {
        fetch('https://yantindash.ddns.net/api/yantinpastrecord/filter/', {
        //fetch('https://webhook.site/f63f6b59-140e-4e81-886b-703cb1d925f8', {
            method: 'POST',
            //mode: 'no-cors', 
            headers: {
                'Accept': 'application/json, text/plain',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                // Your request body content
                type: selectedType,
                //status: selectedStatus,
                startdate: startDate,
                enddate: endDate,
            })
        })
            .then(response => response.json())
            //.then(data => console.log(data))
            .then(data => {
                let mArray = data.map((item) => ({
                    Id: item.item,
                    Label: item.label,
                    Status: item.status,
                    DataType: item.dataType,
                    Timestamp: item.timestamp,
                    Acknowledge: item.acknowledge,
                    Name: item.name
                }));
                console.log(mArray);
                setTArray(mArray);
                console.log(tArray);
                exportToExcel(data, 'MyData');
            }
            )
            .catch((error) => console.error('Error:', error));

    };


    useEffect(() => {
        // Create an instance of HttpClient
        const httpClient1 = axios.create({
            baseURL: 'https://yantindash.ddns.net', // The base URL of your web application
            //baseURL: 'http://103.1.12.190:9443', // The base URL of your web application
            //baseURL: 'http://127.0.0.1:5000', // The base URL of your web application
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const httpClient2 = axios.create({
            baseURL: 'https://yantindash.ddns.net', // The base URL of your web application
            //baseURL: 'http://103.1.12.190:9443', // The base URL of your web application
            //baseURL: 'http://127.0.0.1:5000', // The base URL of your web application
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const getData1 = async () => {
            // Call the web API endpoint with GET method
            await httpClient1.get('/api/estatedevicelocations')
                .then((response) => {
                    const coordinates = response.data.map((item) => ({
                        id: item.deviceLocationId,
                        x: item.positionX,
                        //x: (item.positionX * 600 / 856) -20,
                        y: item.positionY,
                        //y: (item.positionY * 600 / 856) - 30,
                        level: item.deviceDescription,
                    }));

                    // Filter pins with id smaller than 22 and greater than 1
                    //const filteredPins = coordinates.filter(pin => pin.id > 1 && pin.id < 22);
                    let filteredPin_2 = coordinates.filter(pin => pin.id > 0 && pin.id < 40);
                    let scale = 700 / 929;
                    let scaledPin_2 = filteredPin_2.map(fpin => {
                        //return { ...item, x: item.x * scale + 10, y: item.y * scale - 10 };
                        return { ...fpin, id: fpin.id, x: fpin.x * scale + 10, y: fpin.y * scale - 10 };
                    });
                    // Set the pins state with the coordinates
                    setPins_g(scaledPin_2);

                })
                .catch(error => {
                    // Handle the error
                    console.error(error);
                    setRetry(true);
                });
        };
        // Call the web API endpoint with GET method
        const getRecord1 = async () => {

            await httpClient2.get('/api/yantinpastrecord')
                .then((response) => {
                    const recordsDetails = response.data.map((item) => ({
                        id: item.item,
                        label: item.label,

                    }));

                    console.log(recordsDetails);


                    setRecordsDetails(recordsDetails);
                })
                .catch(error => {
                    // Handle the error
                    console.error(error);
                    setRetry(true);
                });
        };

        getData1();
        getRecord1();


    }, [retry]);

    let LoadingClass = ""
    return (
        //<div className="shadow-lg Notification_maindiv">
        <div className=".containerstyle_notification">
            <table>
                
                {/*<td style={{ verticalAlign: "top", width: "400x" }}>
                    <table style={{ verticalAlign: "top" }} >
                        <tr>
                            <div className="floorpin" >
                                <FloorplanImage
                                    src={groundFloor}
                                />
                                <ImageWithPins pins={pins_g} />
                            </div>
                        </tr>
                    </table>
                </td>*/}
                <td>
                    <tr >
                        <div className="shadow-lg Notification_header">
                            <div className="fa fa-bell Notification_icon"></div>

                            <div className="Notification_searchOptiondiv">
                                <div className="Notification_txt">警報類型</div>
                                <select className="Notification_searchOption" onChange={handleSelectedType}>
                                    <option value="0" style={{ background: 'grey' }}>
                                        所有警報
                                    </option>
                                    <option value="1" style={{ background: 'grey' }}>
                                        道路管理
                                    </option>
                                    <option value="2" style={{ background: 'grey' }}>
                                        門口監察
                                    </option>
                                    <option value="3" style={{ background: 'grey' }}>
                                        後巷監察
                                    </option>
                                    <option value="4" style={{ background: 'grey' }}>
                                        水浸監察
                                    </option>
                                    <option value="5" style={{ background: 'grey' }}>
                                        垃圾/回收桶容量監察
                                    </option>
                                    <option value="9" style={{ background: 'grey' }}>
                                        街市鼠蹤夜間監察
                                    </option>
                                </select>
                            </div>
                            <div className="Notification_searchDaterange">
                                <div className="Notification_txt">起始時間</div>
                                <div className="Notification_startdatetimepicker">
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={15}
                                        dateFormat="dd-MM-yyyy HH:mm"
                                        timeCaption="time"
                                    />
                                </div>
                                <div className="Notification_txt">結束時間</div>
                                <div className="Notification_enddatetimepicker">
                                    <DatePicker
                                        selected={endDate}
                                        onChange={handleEndDateChange}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={15}
                                        dateFormat="dd-MM-yyyy HH:mm"
                                        timeCaption="time"
                                    />
                                </div>
                                <div className="buttonstyle" style={{ fontSize: "15px", color: "#202020", backgroundColor: "#BfBfBf" }} onClick={() => handleSearchClick()}>
                                    搜尋
                                </div>
                            </div>
                        </div>
                    </tr>
                    <tr>
                        <div className="Notification_table">
                            <TableList />
                        </div>
                        <div className="Table_bottomdiv">
                            <Pagination />
                        </div>
                    </tr>
                </td>
            </table>
        </div>

    );
}

